<div class="modal-header">
  <h4 class="modal-title">{{title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cancelar')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div [innerHtml]="msg | safeHtml"></div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-success" (click)="activeModal.close('Cerrar')">Cerrar</button>
</div>
